module.exports = __webpack_public_path__ + "img/posting_photo.9e4bc012.svg";